// WASM 초기화 및 함수 re-export 래퍼
import init, {
  overwrite_wallet_data,
  store_encrypted_data,
  store_network_encrypted_data,
  retrieve_encrypted_data,
  retrieve_network_encrypted_data,
  check_pincode_match,
  change_password as change_password_wasm,
  set_wallet_address as set_wallet_address_wasm,
  get_wallet_address as get_wallet_address_wasm,
  set_network_wallet_address as set_network_wallet_address_wasm,
  get_network_wallet_address as get_network_wallet_address_wasm,
  storage_set,
  storage_get,
  storage_remove,
  storage_clear,
} from './rust_wassm_fetch';

// wasmutils의 initializeWasm을 재사용하여 중복 초기화 방지
import { initializeWasm } from './wasmutils';

// ensureWasm을 initializeWasm의 alias로 사용
export const ensureWasm = initializeWasm;

export {
  overwrite_wallet_data,
  store_encrypted_data,
  store_network_encrypted_data,
  retrieve_encrypted_data,
  retrieve_network_encrypted_data,
  check_pincode_match,
  change_password_wasm,
  set_wallet_address_wasm,
  get_wallet_address_wasm,
  set_network_wallet_address_wasm,
  get_network_wallet_address_wasm,
  storage_set,
  storage_get,
  storage_remove,
  storage_clear,
};


